import zip from 'lodash/zip';
import map from 'lodash/map';
import last from 'lodash/last';
import head from 'lodash/head';
import groupBy from 'lodash/groupBy';
import isEmpty from 'lodash/isEmpty';

import { extent } from 'd3';

import { computeValuesProps } from '../dataset/rawTable';

const getBoxData = (boxName, boxValues) => {
  if (isEmpty(boxValues)) {
    return null;
  }

  const props = computeValuesProps(boxValues);

  const {
    firstQuantile, thirdQuantile
  } = computeValuesProps(boxValues);

  const IQR = thirdQuantile - firstQuantile;

  const innerLowerFence = firstQuantile - (1.5 * IQR);
  const outerLowerFence = firstQuantile - (3.0 * IQR);

  const innerUpperFence = thirdQuantile + (1.5 * IQR);
  const outerUpperFence = thirdQuantile + (3.0 * IQR);

  const innerOutliers = [];
  const outerOutliers = [];

  const sortedBoxValuesWithoutOutliers = boxValues.filter(boxValue => {
    if (boxValue < outerLowerFence || boxValue > outerUpperFence) {
      outerOutliers.push(boxValue);
      return false;
    }
    if (boxValue < innerLowerFence || boxValue > innerUpperFence) {
      innerOutliers.push(boxValue);
      return false;
    }
    return true;
  });

  const [
    boxValuesMin,
    boxValuesMax
  ] = extent(sortedBoxValuesWithoutOutliers);

  return {
    name: boxName,

    lowerFence: Math.max(boxValuesMin, innerLowerFence),
    upperFence: Math.min(boxValuesMax, innerUpperFence),

    innerOutliers,
    outerOutliers,

    ...props
  };
};

export const getBoxPlotData = (numericalParameterValues, categoricalParameterValues = null) => {
  if (!categoricalParameterValues) {
    return [getBoxData('', numericalParameterValues)];
  }

  const pairs = zip(
    numericalParameterValues,
    categoricalParameterValues
  );

  return map(groupBy(pairs, last), (chunk, levelName) => {
    return getBoxData(levelName, map(chunk, head));
  });
};
